import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core'
import {AuthService} from '../../services/auth.service'
import {UserProfileService} from '../../services/user-profile.service'
import {InitialPipe} from '../../pipes/initial.pipe'
import {NavigationEnd, Router, RouterModule} from '@angular/router'
import {CommonModule} from '@angular/common'
import {LoadingService} from '../../services/loading.service'
import {ModalConfig, ModalLandPlatformService} from '@sp401/modal-engine'
import {NotificationToastComponent} from 'src/app/components/notification-toast/notification-toast.component'
import {TranslationService} from 'src/app/services/translation.service'
import {AssetPipe} from "../../pipes/asset.pipe";
import {LogoutLoaderModalComponent} from 'src/app/modal/logout-loader-modal/logout-loader-modal.component'
import {CacheService} from 'src/app/services/cache.service'
import {filter} from 'rxjs'
import {GTM_EVENTS} from '../../constants/gtm-events.constants';
import {GtmService} from 'src/app/services/gtm.service';

@Component({
  selector: 'fleet-header',
  standalone: true,
  imports: [
    CommonModule,
    InitialPipe,
    RouterModule,
    NotificationToastComponent,
    AssetPipe
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderComponent {
  GTM_EVENTS = GTM_EVENTS;
  cdr = inject(ChangeDetectorRef)
  translation: any;

  modalConfig: any = {
    modalId: 'logout_modal',
    type: 'simple',
    dismissible: true,
    title: 'Are you sure you want to logout?',
    level: 'INFO',
    contentConfig: {
      bodyMessage: 'You will log out of the website',
      showDialogControl: {
        submit: true,
        cancel: true,
      },
      label: {
        submitLabel: 'Continue',
        cancelLabel: 'Cancel',
      },
      submitFunction: () => {
        this.doLogout()
      },
      cancelFunction: () => {
        this.cancelLogout();
      }
    },
  }

  loadingLogoutModal: ModalConfig = {
    modalId: 'loading_logout_modal',
    type: 'simple',
    dismissible: false,
    title: '',
    level: 'INFO',
    contentConfig: {
      componentRender: LogoutLoaderModalComponent
    },
    // {
    //   bodyMessage: 'Just few seconds and you will be disconnected',
    //   showDialogControl: false,
    // },
  }

  isLogged: boolean = false
  userProfile: any = {}
  showPanel: boolean = false

  @Input() whiteHeaderUserPanel: boolean = false
  urlAfterRedirects: string = "";
  isAPICalled = false;

  constructor(
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private _modal: ModalLandPlatformService,
    private _loading: LoadingService,
    private router: Router,
    private translationService: TranslationService,
    private cacheService: CacheService,
    private GtmService: GtmService
  ) {
    this.authService.loggedInObservable.subscribe((value: boolean) => {
      this.isLogged = value
      if (this.isLogged && !Object.keys(this.userProfile).length) {
        this.fillUserProfileInformation()
      }
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        if (event.urlAfterRedirects == '/en-US') {
          this.urlAfterRedirects = event.urlAfterRedirects;
          let stateData = this.router.getCurrentNavigation()?.extras?.state;
          if (stateData?.['loginStatus']) {
            if (this.isLogged) {
              this.fillUserProfileInformation();
            }
            this.isLogged = stateData?.['loginStatus'] as boolean;
          } else {
            if (this.isLogged) {
              this.fillUserProfileInformation();
            }
            this.isLogged = history?.state?.loginStatus;
          }
        } else {
          this.urlAfterRedirects = "";
        }
      });
  }

  ngAfterContentChecked() {
    if (this.isLogged && this.urlAfterRedirects.length > 0 && !this.isAPICalled) {
      this.isAPICalled = true;
      this.fillUserProfileInformation();
    }
    this.cdr.markForCheck()
  }

  ngOnInit() {
    this.translation = this.translationService.getTranslationForPage('home');
  }

  fillUserProfileInformation(): void {
    this._loading.showLoading()
    this.userProfileService.getProfileData().then((value) => {
      this.userProfile = value.data.profile
      this._loading.hideLoading()
      this.cdr.markForCheck()
    })
  }

  triggerLogout() {
    this.trackEvent(this.translation['home.logout']);
    this._modal.triggerAddModal(this.modalConfig)
  }

  doLogout() {
    this._modal.triggerAddModal(this.loadingLogoutModal)
    this.authService.logout().then(() => {
      this.authService.setIsLogged(false)
      this.cacheService.clearCache();
      this.router.navigate(['/login'])
    })
  }

  isActive(path: any) {
    if (this.router.url?.includes(path)) {
      return true;
    }
    return false
  }

  cancelLogout() {
    this._modal.triggerCloseModal(this.modalConfig['id']);
  }

  navigateToPage() {
    this.trackEvent('logo_stellantis');
    this.router.navigateByUrl("/", {state: {loginStatus: this.isLogged}});
  }

  trackEvent(name: string) {
    this.GtmService.trackEvent(this.GtmService.formatEventWithParams(GTM_EVENTS.HEADER_CLICK, {
      label: (name.toLowerCase().trim()).replace(/\s+/g, '-'),
    }))
  }
}
